import { HomeComponent } from './../home/home.component';
import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material';
import { GLOBAL } from 'src/app/services/global';

@Component({
  selector: "page-auxUrlcert",
  templateUrl: "auxUrlcert.component.html",
  styleUrls: ["./auxUrlcert.component.css"]
})

export class AuxUrlcertComponent {
  public filedomSolicitudUrl = GLOBAL.filedomSolicitudUrl;
  public filedomSeguimientoUrl = GLOBAL.filedomSeguimientoUrl;
  public certificadoFiledom = GLOBAL.certificadoFiledom;
  public seguimientoCertFiledom = GLOBAL.seguimientoCertFiledom;
  constructor(private dialog: MatDialog, private _router: Router) {

  }

  sign(tipo) {
    //  alert(tipo);
    if (sessionStorage.getItem("identity-domCloud") && sessionStorage.getItem("token-domCloud")) {
      this.dialog.closeAll();
      if (tipo == 'certificados') {
        window.open(`https://arcgismlc.lascondes.cl/visorterritorial/`, '_blank');
        //window.open(`/#/certificados`, '_blank');
      } else if (tipo == 'seguimiento_expediente') {
        // console.log("seguimiento expediente 1");
        this._router.navigate(['/seguimiento_certificados'])
        this.dialog.closeAll()
        // this._router.navigate([`/seguimiento_expediente`]);
      } else if (tipo == 'derecho') {
        this._router.navigate([`/pago_calculo_derecho`]);
      }
    } else {
      if (tipo == 'certificados') {
        window.open(`https://arcgismlc.lascondes.cl/visorterritorial/`, '_blank');
        // this._router.navigate([`/certificados`]);
      } else if (tipo == 'seguimiento_expediente') {
        localStorage.setItem("navdomcloud", 'seguimiento_expediente')
        this._router.navigate(['/seguimiento_certificados'])
        this.dialog.closeAll()
      } else if (tipo == 'derecho') {

        window.open(`/#/pago_calculo_derecho`, '_blank');

      }
    }
  }
}
